import React, { Component } from 'react';
import Channels from './Channels';
import { BarChart, Bar, Brush, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import Weather from './Weather';
var moment = require('moment');
export default class ChartTest extends Component {
    static displayName = ChartTest.name;

    constructor(props) {
        super(props);
        this.state = {
            counts: [],
            siteID: props.site.id,
            siteName: props.site.name,
            currentSite: props.site,
            channels: [],
            step: ""
        };
    }
    handleClick = (data, index) => {
        var date = moment(data.Date).format();
        date = date.substring(0, date.lastIndexOf("-"));
        if (this.state.step === "month") {
            fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/day/" + date)
                .then(response => response.json())
                .then(data => {
                    this.setState({ counts: data, step: "day" });
                });
        } else if (this.state.step === "day") {
            fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/15m/" + date)
                .then(response => response.json())
                .then(data => {
                    this.setState({ counts: data, step: "15m" });
                });
        }
        else if (this.state.step === "15m") {
            fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/month")
                .then(response => response.json())
                .then(data => {
                    this.setState({ counts: data, step: "month" });
                });
        }
    }
    componentDidMount() {
        this.state.siteID !== 0 && fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/month")
            .then(response => response.json())
            .then(data => {
                this.setState({ counts: data, step: "month", siteID: this.props.site.id, siteName: this.props.site.name, currentSite: this.props.site, channels: this.props.site.channels});
                
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.site.id !== this.props.site.id) {
            this.setState({ siteID: this.props.site.id, siteName: this.props.site.name, currentSite: this.props.site, channels: this.props.site.channels }, () => {
                fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/month")
                    .then(response => response.json())
                    .then(data => {
                        this.setState({ counts: data, step: "month" });
                        
                    });
            });
        }
    }

    
    

    render() {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var data = [];
        var step = this.state.step;
        var title = "Total Count Data";
        this.state.counts.forEach(function (item) {
            var date = item.date;
            date = date.substring(0, date.indexOf('+'));
            var newDate = new Date(Date.parse(date));
            newDate.setHours(newDate.getHours() + 5);
            var dateString = ""
            if (step === "month") {
                dateString = monthNames[newDate.getMonth()] + ", " + newDate.getFullYear();
                data.push({
                    'Date': dateString,
                    'Count': item.counts,
                    'Click Me!': '' 
                });
            } else if (step === "day") {
                dateString = monthNames[newDate.getMonth()] + " " + newDate.getDate() + ", " + newDate.getFullYear();
                data.push({
                    'Date': dateString,
                    'Count': item.counts,
                    'Click Me!': '' 
                });
                title = "Total Count Data - " + moment(newDate).format("MMM, YYYY");
            } else if (step === "15m") {
                dateString = moment(newDate).format("hh:mm a");
                data.push({
                    'Date': dateString,
                    'Count': item.counts,
                    'Click Me!': '' 
                });
                title = "Total Count Data - " + moment(newDate).format("MMM DD, YYYY");
            }
        });
        var displayData = (
            <div className="container-fluid">
                <h1 className="display-4" style={{ textAlign: 'center' }}>{this.state.siteName.slice(this.state.siteName.indexOf('-') + 1)}</h1>
                
                <div className="row" style={{ textAlign: 'center' }}>
                    <h4 style={{ fontWeight: 400, margin: '0 auto' }}>{title}</h4>
                    <div style={{width: '100%', height: 300}}>
                        <ResponsiveContainer>
                            <BarChart
                                width={700}
                                height={300}
                                data={data}
                                margin={{
                                    top: 5, right: 30, left: 20, bottom: 5
                                }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="Date" />
                                <YAxis />
                                <Tooltip />
                                <Brush dataKey="Date" height={30} stroke="#7d83ff" />
                                <Bar dataKey="Count" onClick={this.handleClick} fill="rgba(169,92,144, .7)" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div> <br />
                <div>
                    <h4 className="channelTitle" style={{ fontSize: '2.1rem', textAlign: 'center', fontWeight: 300, lineHeight: 1.2 }}>Individual Counter Data</h4>
                    {this.state.currentSite.channels.length > 0 && this.state.currentSite.channels.map(channel => {
                        return (

                            <Channels id={channel.id} key={channel.id} name={channel.name} userType={channel.userType} />

                        )
                    })}
                </div>
                
            </div>
        );
        return displayData; //return this.state.counts.length > 0 ? displayData : <p className="lead">Please select a site on the map to see the count data</p>;
    }
}


// WEBPACK FOOTER //
// ./src/components/ChartTest.js